import type { TourChapterDef } from '../types';
import { ownerChapters } from './owner';

const skip = new Set([
  'owner.employees',
  'owner.managers',
  'owner.contracts',
]);

/** Manager sequence = owner pages they can access, plus my-jobs; no billing step in settings. */
export const managerChapters: TourChapterDef[] = [
  ...ownerChapters
    .filter((c) => !skip.has(c.id))
    .map((c) => {
      if (c.id === 'owner.settings') {
        return {
          ...c,
          id: 'manager.settings',
          steps: c.steps.filter((s) => s.target !== '[data-tour="settings-credits"]'),
        };
      }
      if (c.id === 'owner.help') {
        return { ...c, id: 'manager.help' };
      }
      if (c.id === 'owner.dashboard') {
        return {
          ...c,
          id: 'manager.dashboard',
          steps: c.steps.filter((s) => s.target !== '[data-tour="navbar-credits"]'),
        };
      }
      return { ...c, id: c.id.replace(/^owner\./, 'manager.') };
    }),
  // Insert my-jobs before activity (matches managerNav order roughly - after positions/jobs)
].reduce<TourChapterDef[]>((acc, ch) => {
  acc.push(ch);
  if (ch.id === 'manager.positions') {
    acc.push({
      id: 'manager.my-jobs',
      titleKey: 'my.jobs',
      route: '/my-jobs',
      useSampleData: true,
      steps: [
        {
          target: '[data-tour="myjobs-list"]',
          titleKey: 'tour.ch.myjobs.list.title',
          bodyKey: 'tour.ch.myjobs.list.body',
          route: '/my-jobs',
          placement: 'top',
        },
      ],
    });
  }
  return acc;
}, []);
